// HTML, not svg: report exports grab the first svg in the figure. Every
// view's summary sits hidden in the same spot, so the tallest one sets the
// height and switching views never moves the chart.
export function FlowSummary({
  summary,
  roomFor,
}: {
  summary: string
  roomFor: string[]
}) {
  if (!roomFor.some(Boolean)) return null
  return (
    <div className="mb-4 grid max-w-3xl text-pretty text-sm text-ink-subtle">
      {[...new Set(roomFor)].map((text) => (
        <p key={text} aria-hidden className="invisible col-start-1 row-start-1">
          {text}
        </p>
      ))}
      <p className="col-start-1 row-start-1">{summary}</p>
    </div>
  )
}
